import Acquisition from './stages/acquisition'
import Reengagement from './stages/reengagement'
import Retargeting from './stages/retargeting'
import Retention from './stages/retention'

const Funnel = ({ availableStages = [], audienceSelections = [] }) => {
    const getActiveState = (stage) => {
        if (!availableStages.includes(stage)) return false

        return audienceSelections[stage]?.length > 0
    }

    return (
        <div className="tw:flex tw:flex-col tw:gap-6">
            <span className="tw:text-sm tw:font-semibold tw:text-center">Sales Funnel</span>
            <div className="tw:flex tw:flex-col tw:items-center">
                <Acquisition
                    active={getActiveState('acquisition')}
                    disabled={!availableStages.includes('acquisition')}
                />
                <Reengagement
                    active={getActiveState('reengagement')}
                    disabled={!availableStages.includes('reengagement')}
                />
                <Retargeting
                    active={getActiveState('retargeting')}
                    disabled={!availableStages.includes('retargeting')}
                />
                <Retention active={getActiveState('retention')} disabled={!availableStages.includes('retention')} />
            </div>
        </div>
    )
}

export default Funnel
